// The blåtur rules as data, shared by the rules page and the e-mails
// Based on the original blåtur rules (Pula, 2017) and the changes agreed on blåtur 2026

export const TAGLINE = 'Årlig tur med ukjent destinasjon, siden Pula 2017.';
export const FOUNDED = 'Blåtur ble startet av Njaal og Magnus, som arrangerte den første turen til Pula i 2017.';
export const APPLY_TO = 'Njaal, Magnus eller Matias';

export const RULES = [
  { text: 'Blåtur arrangeres hvert år.' },
  {
    text: 'Takker man nei to turer på rad, mister man invitasjonen.',
    highlight: "Two strikes, and you're out.",
    details: [
      'Regelen praktiseres fra høsten 2026. Den som uteble fra både 2025- og 2026-turen, må søke for å bli med i 2027.',
      'Årsaken skal alltid høres før noe registreres som strike. Vi skal være rause.',
      'Det er arrangørene for den aktuelle turen som vurderer og registrerer striken.',
      `Den som er ute kan sende en skriftlig søknad til ${APPLY_TO} om å komme inn igjen, og må regne med en straff.`,
    ],
  },
  {
    text: 'Under hver tur utnevner arrangørene neste års arrangører.',
    details: [
      'Hvordan de utnevnes er opp til arrangørene.',
      'En tidligere arrangør kan ikke velges igjen før alle har vært arrangør. Da «resettes» det.',
      'Samtidig kan det foreslås nye ansikter, som meldes inn som aspiranter.',
    ],
  },
  { text: 'Arrangørene setter datoer så tidlig som mulig, helst rett etter fjorårets tur. Det lages event, og deltakerne inviteres.' },
  { text: 'Samme destinasjon kan ikke gjenbrukes før det har gått to runder, altså at alle har vært arrangør to ganger.' },
  { text: 'Det skal tas et gruppebilde under hver tur. Hver eneste gang.' },
  {
    text: 'Nye kommer inn som aspiranter.',
    details: [
      'De på invitasjonslisten kan melde inn nye. Den som meldes inn, er aspirant til de blir tatt inn.',
      'En aspirant kan inviteres når de har møtt minst 8 av dem på invitasjonslisten på andre arrangementer enn blåtur.',
      'Alle på invitasjonslisten kan legge ned veto. En veto stopper opptak til den trekkes, eller arrangørene overstyrer den.',
      'Det er arrangørene som tar aspiranter inn på invitasjonslisten.',
    ],
  },
];

export const CHANGED_2026 = 'Den opprinnelige regelen om at bare de opprinnelig inviterte kan delta, gjelder ikke lenger. '
  + 'Blåtur skal ta inn nye folk som er godt kjent i gjengen, gjennom aspirantordningen.';

// Short version for the invitation e-mail
export const RULES_SUMMARY = [
  'Destinasjonen er hemmelig til dere er på vei. Arrangørene bestemmer innhold, tidspunkt og pris.',
  'Blåtur skal stå øverst på prioriteringslisten. Takker du nei to turer på rad, mister du invitasjonen.',
  'Arrangørene for neste tur utnevnes under turen, og alle får sin tur som arrangør.',
  'Det tas gruppebilde hver eneste gang.',
];
